import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { PackageIcon, FileTextIcon, TicketIcon, UsersIcon, CalendarIcon, AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
export function LicenseDashboard({
  locale,
  onNavigate
}) {
  // Mock data for the dashboard
  const summaryData = {
    totalModules: 8,
    activeModules: 6,
    volumeUsage: {
      current: 75420,
      limit: 100000,
      metric: 'Documents',
      percentage: 75
    },
    occasionalPasses: {
      remaining: 42,
      used: 18,
      total: 60
    },
    activeSessions: 14,
    renewalDue: 45
  };
  const alerts = [{
    id: 'alert-1',
    type: 'warning',
    message: 'Vendor Management module license expires in 7 days',
    action: 'Renew Now',
    module: {
      id: 'module-2',
      name: 'Vendor Management'
    }
  }, {
    id: 'alert-2',
    type: 'danger',
    message: 'Document volume usage at 75% of limit',
    action: 'Upgrade Plan',
    plan: {
      id: 'plan-1',
      name: 'Enterprise Document Plan'
    }
  }];
  return <div className="space-y-6" data-id="element-15567">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-15568">
        {/* Licensed Modules */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-15569">
          <div className="px-4 py-5 sm:p-6" data-id="element-15570">
            <div className="flex items-center" data-id="element-15571">
              <div className="flex-shrink-0 bg-indigo-100 rounded-md p-3" data-id="element-15572">
                <PackageIcon className="h-6 w-6 text-indigo-600" data-id="element-15573" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-15574">
                <dl data-id="element-15575">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-15576">
                    Licensed Modules
                  </dt>
                  <dd data-id="element-15577">
                    <div className="text-lg font-medium text-gray-900" data-id="element-15578">
                      {summaryData.activeModules} / {summaryData.totalModules}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-15579">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-15580">
                View all modules
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-15581" />
              </button>
            </div>
          </div>
        </div>
        {/* Volume Usage */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-15582">
          <div className="px-4 py-5 sm:p-6" data-id="element-15583">
            <div className="flex items-center" data-id="element-15584">
              <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-15585">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-15586" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-15587">
                <dl data-id="element-15588">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-15589">
                    Volume Usage ({summaryData.volumeUsage.metric})
                  </dt>
                  <dd data-id="element-15590">
                    <div className="text-lg font-medium text-gray-900" data-id="element-15591">
                      {summaryData.volumeUsage.current.toLocaleString()} /{' '}
                      {summaryData.volumeUsage.limit.toLocaleString()}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-15592">
              <div className="relative" data-id="element-15593">
                <div className="overflow-hidden h-2 text-xs flex rounded bg-blue-100" data-id="element-15594">
                  <div style={{
                  width: `${summaryData.volumeUsage.percentage}%`
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500" data-id="element-15595"></div>
                </div>
                <div className="text-xs text-gray-500 mt-1 text-right" data-id="element-15596">
                  {summaryData.volumeUsage.percentage}% used
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Occasional Passes */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-15597">
          <div className="px-4 py-5 sm:p-6" data-id="element-15598">
            <div className="flex items-center" data-id="element-15599">
              <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-15600">
                <TicketIcon className="h-6 w-6 text-green-600" data-id="element-15601" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-15602">
                <dl data-id="element-15603">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-15604">
                    Occasional Passes
                  </dt>
                  <dd data-id="element-15605">
                    <div className="text-lg font-medium text-gray-900" data-id="element-15606">
                      {summaryData.occasionalPasses.remaining} remaining
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-15607">
              <button type="button" onClick={() => onNavigate('passes')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-15608">
                Manage passes
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-15609" />
              </button>
            </div>
          </div>
        </div>
        {/* Active Sessions */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-15610">
          <div className="px-4 py-5 sm:p-6" data-id="element-15611">
            <div className="flex items-center" data-id="element-15612">
              <div className="flex-shrink-0 bg-purple-100 rounded-md p-3" data-id="element-15613">
                <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-15614" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-15615">
                <dl data-id="element-15616">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-15617">
                    Active Sessions
                  </dt>
                  <dd data-id="element-15618">
                    <div className="text-lg font-medium text-gray-900" data-id="element-15619">
                      {summaryData.activeSessions} today
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-15620">
              <button type="button" onClick={() => onNavigate('usage')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-15621">
                View usage details
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-15622" />
              </button>
            </div>
          </div>
        </div>
        {/* Renewal Due */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-15623">
          <div className="px-4 py-5 sm:p-6" data-id="element-15624">
            <div className="flex items-center" data-id="element-15625">
              <div className="flex-shrink-0 bg-yellow-100 rounded-md p-3" data-id="element-15626">
                <CalendarIcon className="h-6 w-6 text-yellow-600" data-id="element-15627" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-15628">
                <dl data-id="element-15629">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-15630">
                    Next Renewal
                  </dt>
                  <dd data-id="element-15631">
                    <div className="text-lg font-medium text-gray-900" data-id="element-15632">
                      {summaryData.renewalDue} days
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-15633">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-15634">
                View renewals
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-15635" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Alerts */}
      <div className="bg-white shadow sm:rounded-lg" data-id="element-15636">
        <div className="px-4 py-5 sm:px-6" data-id="element-15637">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-15638">
            License Alerts
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-15639">
            Important notifications about your licenses and usage
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-15640">
          <div className="divide-y divide-gray-200" data-id="element-15641">
            {alerts.map(alert => <div key={alert.id} className="px-4 py-4 sm:px-6" data-id="element-15642">
                <div className="flex items-start" data-id="element-15643">
                  <div className={`flex-shrink-0 ${alert.type === 'warning' ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-15644">
                    <AlertTriangleIcon className="h-5 w-5" data-id="element-15645" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-15646">
                    <p className="text-sm font-medium text-gray-900" data-id="element-15647">
                      {alert.message}
                    </p>
                    <div className="mt-3 flex" data-id="element-15648">
                      <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={() => {
                    if (alert.module) {
                      onNavigate('module-detail', alert.module);
                    } else if (alert.plan) {
                      onNavigate('plan-detail', alert.plan);
                    }
                  }} data-id="element-15649">
                        {alert.action}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
            {alerts.length === 0 && <div className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-15650">
                No alerts at this time. All licenses are in good standing.
              </div>}
          </div>
        </div>
      </div>
    </div>;
}